"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateExchangeCodes = exports.getPKCELoginUrl = exports.getAuthRedirectUri = exports.getLoginUrlParametric = void 0;
const cryptoJS = __importStar(require("crypto-js"));
const Config_1 = require("../Config");
const getLoginUrlParametric = ({ responseType, scope, clientId, redirectUri, state, codeChallenger }) => {
    const loginUrl = new URL(`${(0, Config_1.getConfigValue)('AUTH_ENDPOINT')}/auth`);
    loginUrl.searchParams.append('response_type', responseType);
    if (codeChallenger)
        loginUrl.searchParams.append('code_challenge', codeChallenger);
    loginUrl.searchParams.append('scope', scope);
    loginUrl.searchParams.append('client_id', clientId);
    loginUrl.searchParams.append('redirect_uri', redirectUri);
    loginUrl.searchParams.append('state', state);
    return loginUrl.href;
};
exports.getLoginUrlParametric = getLoginUrlParametric;
const getAuthRedirectUri = () => {
    const urlObject = new URL(window.location.href.replace(/#/g, "?"));
    return `${urlObject.origin}/login`;
};
exports.getAuthRedirectUri = getAuthRedirectUri;
const getPKCELoginUrl = (codeChallenger, backPath) => {
    return (0, exports.getLoginUrlParametric)({
        responseType: 'code',
        scope: 'offline_access openid',
        clientId: (0, Config_1.getConfigValue)('AUTH_CLIENT_ID'),
        redirectUri: (0, exports.getAuthRedirectUri)(),
        state: backPath ?? '',
        codeChallenger
    });
};
exports.getPKCELoginUrl = getPKCELoginUrl;
const generateRandomString = (length) => {
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let randomString = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        randomString += charset.charAt(randomIndex);
    }
    return randomString;
};
function base64url(str) {
    return str.toString(cryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
const generateCodeChallenge = (codeVerifier) => {
    return base64url(cryptoJS.SHA256(codeVerifier));
};
const generateExchangeCodes = () => {
    const codeVerifier = generateRandomString(40);
    const codeChallenger = generateCodeChallenge(codeVerifier);
    return {
        codeVerifier,
        codeChallenger,
    };
};
exports.generateExchangeCodes = generateExchangeCodes;
